<template>
  <div class="bg-white rounded">
    <div class="list-group-item">
      <div class="row d-none d-lg-flex">
        <div :class="`col-lg-${showTime?'2':'3'} fw-600`">{{ $t("Apply_Money") }}</div>
        <div :class="`col-lg-${showTime?'2':'3'} fw-600`">{{ $t("Fee") }}</div>
        <div :class="`col-lg-${showTime?'2':'3'} fw-600`">{{ $t("到账") }}</div>
        <div v-if="showTime" class="col-lg-3 fw-600">{{ $t("Apply_Time") }}</div>
        <div class="col-lg-3 fw-600">{{ $t("提款订单状态") }}</div>
      </div>
    </div>
    <van-list
      :finished="finished"
      :finished-text="$t('No_More_Data')"
      :offset="500"
      :value="loading"
      @load="onLoad"
    >
      <div v-for="(item, index) in list" :key="index" class="list-group-item">
        <div class="row">
          <div :class="`d-flex col-lg-${showTime?'2':'3'}`">
            <div class="d-lg-none">{{ $t("Apply_Money") }}：</div>
            <div>{{ formatMoney(item.applyAmount) }}</div>
          </div>
          <div :class="`d-flex col-lg-${showTime?'2':'3'}`">
            <div class="d-lg-none">{{ $t("Fee") }}：</div>
            <div>{{ formatMoney(item.fee) }}</div>
          </div>
          <div :class="`d-flex col-lg-${showTime?'2':'3'}`">
            <div class="d-lg-none">{{ $t("到账") }}：</div>
            <div>{{ formatMoney(item.amount) }}</div>
          </div>
          <div v-if="showTime" class="d-flex col-lg-3">
            <div class="d-lg-none">{{ $t("Apply_Time") }}：</div>
            <div>{{ item.createTime }}</div>
          </div>
          <div class="d-flex col-lg-3 text-red">
            <div class="d-lg-none">{{ $t("提款订单状态") }}：</div>
            <div>
              {{ $t(`提款订单状态_${item.status}`) }}
              <span v-if="item.rejectReason">( {{ item.rejectReason }} )</span>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { getList } from "@/api/user.withdraw";

export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      curPage: 0,
      pageSize: 10
    };
  },
  computed:{
    showTime(){
      return this.paramMapAll['USER_BILL_TIME_HIDE'] !== '1'
    },
  },
  methods: {
    onLoad() {
      if (this.finished) return;
      this.curPage++;
      this.loading = true;
      getList({
        curPage: this.curPage,
        pageSize: this.pageSize
      }).then(res => {
        let data = res.data;
        data.list && (this.list = this.list.concat(data.list));
        this.loading = false;
        if (this.curPage >= parseInt(data.totalPage)) {
          // 最后一页没有更多了
          this.finished = true;
        }
      });
    }
  },
  created() {
    this.onLoad();
  }
};
</script>
<style scoped>
.item {
  background: #fff;
  opacity: 1;
  border-radius: 10px;
  margin-top: 11px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-shadow: 0 0 5px #ccc;
  box-shadow: 0 0 5px #ccc;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-line-pack: center;
  align-content: center;
  -ms-flex-item-align: center;
  align-self: center;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: 11px 14px;
  position: relative;
  z-index: 1;
}

.text-red {
  color: red !important;
}

.text-green {
  color: #00a300 !important;
}
</style>
